import { NeighborhoodNodeOverlayBehavior } from '@ispm/shared/bpmn-io/behavior/neighborhood-node-overlay-behavior';
import EventBus from 'diagram-js/lib/core/EventBus';
import { TreeNavigator } from '@ispm/shared/bpmn-io/services/tree-navigator';
import { select, Store } from '@ngrx/store';
import { ProcessUserSelectedElementAction, UpdateLatestSelectedNodeIdAction } from '../../store/actions';
import { Node } from '../../models/node';
import { State } from '../../store/state';
import { selectExecutionPath, selectNodesForSelection } from '../../store/selectors';
import { Shape } from 'diagram-js/lib/model';
import { ExecutionPath } from '@ispm-client/modules/process-executor';
import { TreePathNavigator } from '@ispm-client/modules/process-executor/bpmn/services/tree-path-navigator';
import { InjectionNames } from '@ispm/shared/bpmn-io/bpmn-js';
import { DimNodesService } from '@ispm-client/modules/process-executor/bpmn/services/dim-nodes.service';

export class NeighborhoodOverlayBehaviorOnExecution extends NeighborhoodNodeOverlayBehavior {

  protected viewer;
  private nodesForSelection: Node[];
  private executionPath: ExecutionPath;

  constructor(eventBus: EventBus, protected overlays,
              protected treeNavigator: TreeNavigator,
              private store$: Store<State>,
              private treePathNavigator: TreePathNavigator,
              protected dimNodesService: DimNodesService) {
    super(eventBus, overlays, treeNavigator);
    this.store$.pipe(select(selectNodesForSelection)).subscribe(nodesForSelection => this.nodesForSelection = nodesForSelection);
    this.store$.pipe(select(selectExecutionPath)).subscribe(path => this.executionPath = path);
  }

  neighborhoodEntryOnClick(element: Shape) {
    const result = this.nodesForSelection.find(nodeForSelection => nodeForSelection.nodeId === (element.id));
    if (!!result) {
      this.store$.dispatch(new UpdateLatestSelectedNodeIdAction({ id: element.id}));
      this.store$.dispatch(new ProcessUserSelectedElementAction({
        id: element.id,
        name: element.businessObject.name
      }));
    } else {
      super.neighborhoodEntryOnClick(element);
    }
    this.dimNodes();
  }

  navigateToMainTree(node: Shape) {
    super.navigateToMainTree(node);
    this.treePathNavigator.recenterMainTreeExitingNeighborhood(this.executionPath);
    this.dimNodes();
  }

  private dimNodes() {
    this.dimNodesService.dimNodes(this.executionPath);
  }
}

NeighborhoodOverlayBehaviorOnExecution.$inject = [...NeighborhoodNodeOverlayBehavior.$inject, 'store$', InjectionNames.treePathNavigator, InjectionNames.dimNodesService];
